import styled from 'styled-components';
import { colors, fontSize } from '../theme';

const Textbox = styled.p<{ textAlign?: string }>`
    color: ${colors.gray};
    text-align: ${({ textAlign }) => textAlign || 'left'};
    font-size: ${fontSize.medium};
`;
export default Textbox;
